import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <h1 className="text-3xl md:text-4xl font-black tracking-tight mb-12 text-[#111]" data-testid="terms-title">Kurum Tüzüğü</h1>

        <div className="space-y-10 text-base leading-relaxed text-neutral-600">
          <section>
            <h2 className="text-xl font-black tracking-tight text-[#111] mb-3">1. Genel Koşullar</h2>
            <p>Bu platformu kullanan herkes aşağıdaki şartları kabul etmiş sayılır. TestettiK®, ürünlerin bağımsız değerlendirmesini yapar ve sonuçları şeffaf şekilde yayınlar.</p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-[#111] mb-3">2. Ürün Gönderimi</h2>
            <p>Ürün gönderen marka ve satıcılar, ürünlerinin bağımsız olarak test edileceğini, puanlanacağını ve sonuçların olumlu ya da olumsuz fark etmeksizin yayınlanacağını kabul eder. Test sonucu için herhangi bir garanti verilmez.</p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-[#111] mb-3">3. Değerlendirme Süreci</h2>
            <div className="space-y-3">
              <p>Tüm ürünler fiziksel olarak test edilir ve 0–10 arasında puanlanır.</p>
              <div className="border border-neutral-200 rounded-lg p-4 space-y-2">
                <p className="font-bold text-[#111]">7.0 ve üzeri → <span className="text-[#1C3B2A]">Test Başarılı</span></p>
                <p className="font-bold text-[#111]">7.0 altı → <span className="text-[#A63333]">Beklentiyi Karşılamadı</span></p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-[#111] mb-3">4. TestettiK® Güven Rozeti ve Geçerlilik</h2>
            <div className="space-y-3">
              <p>Test başarılı olan ürünlere verilen TestettiK® Güven Rozeti, yalnızca belirli bir süre için geçerlidir.</p>
              <p>Geçerlilik süresi sona erdiğinde:</p>
              <ul className="space-y-2">
                <li className="flex items-start gap-2.5"><span className="text-[#1C3B2A] mt-0.5">•</span>Ürünün doğrulama durumu aktif olmaktan çıkar</li>
                <li className="flex items-start gap-2.5"><span className="text-[#1C3B2A] mt-0.5">•</span>Doğrulama sayfası aktif doğrulama statüsünü kaybeder</li>
                <li className="flex items-start gap-2.5"><span className="text-[#1C3B2A] mt-0.5">•</span>Sayfa kullanıcıya "doğrulama geçerli değil" bilgisi gösterir</li>
              </ul>
              <p>Bu durumda ürün, platformda aktif doğrulama kapsamında sunulmaz. Geçmiş test sonucu yalnızca arşiv niteliği taşır ve güncel doğrulama anlamı ifade etmez.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-[#111] mb-3">5. Sorumluluk</h2>
            <p>TestettiK®, değerlendirmeleri kendi test sürecine göre oluşturur ancak ürünlerin satın alınması, kullanımı veya sonuçlarından doğabilecek doğrudan veya dolaylı zararlardan sorumlu tutulamaz.</p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-[#111] mb-3">6. Değişiklikler</h2>
            <p>Bu koşullar gerekli görüldüğünde güncellenebilir. Güncellenen şartlar platformda yayınlandığı anda yürürlüğe girer.</p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;
